import styled from 'styled-components'
import { Main } from './styled'
import { LoadingContent } from './loader'
import { useAccount } from '../hooks/apollo/use-account'

const StyledMainLoadingContent = styled(Main).attrs(() => ({
  as: LoadingContent,
}))`
  margin-top: 96px;

  & > * {
    margin-bottom: 128px;
  }
`

export const AccountProvider = ({ children }) => {
  const { account = {}, loading: isAccountLoading } = useAccount()

  return <StyledMainLoadingContent isLoading={!account || isAccountLoading}>{children}</StyledMainLoadingContent>
}
